<template>
  <div
    id="inspire"
    class="fill-height"
  >
    <v-app-bar data-cy="public-qa-app-bar">
      <v-app-bar-title>SiteLOG</v-app-bar-title>
    </v-app-bar>
    <v-main>
      <v-container max-width="1200">
        <v-stepper
          v-model="step"
          mobile-breakpoint="sm"
          data-cy="public-qa-stepper"
        >
          <v-stepper-header>
            <v-stepper-item
              :value="1"
              data-cy="public-qa-step-review"
            >
              Pregled dokumenta
            </v-stepper-item>
            <v-stepper-item
              :value="2"
              data-cy="public-qa-step-notes"
            >
              Dodajanje opomb
            </v-stepper-item>
            <v-stepper-item
              :value="3"
              data-cy="public-qa-step-finished"
            >
              Zaključek
            </v-stepper-item>
          </v-stepper-header>
          <v-stepper-window>
            <!-- Pregled PDF -->
            <v-stepper-window-item :value="1">
              <v-card-actions class="justify-end">
                <v-btn
                  color="primary"
                  variant="outlined"
                  data-cy="public-qa-next-to-notes"
                  @click="step = 2"
                >
                  Naprej
                </v-btn>
              </v-card-actions>
              <PdfPreview :document-url="documentUrl" />
            </v-stepper-window-item>

            <v-stepper-window-item :value="2">
              <v-textarea
                v-model="notes.dopolnilni_del"
                label="6. Dodatne ugotovitve, navodila in sporočila izvajalcu"
                :messages="siteLog.dopolnilni_del ? ['Prejšnji vnosi: ' + siteLog.dopolnilni_del] : []"
                auto-grow
                data-cy="public-qa-note-op6"
              />

              <v-textarea
                v-model="notes.opombe_in_zahteve_odgovornega_vodje"
                label="6.a Opombe odgovornega vodje projekta"
                :messages="siteLog.opombe_in_zahteve_odgovornega_vodje ? ['Prejšnji vnosi: ' + siteLog.opombe_in_zahteve_odgovornega_vodje] : []"
                auto-grow
                data-cy="public-qa-note-op6a"
              />

              <v-textarea
                v-model="notes.opombe_in_zahteve_inspekcijskih_sluzb"
                label="6.b Opombe inšpekcijskih služb"
                :messages="siteLog.opombe_in_zahteve_inspekcijskih_sluzb ? ['Prejšnji vnosi: ' + siteLog.opombe_in_zahteve_inspekcijskih_sluzb] : []"
                auto-grow
                data-cy="public-qa-note-op6b"
              />

              <v-textarea
                v-model="notes.opombe_in_zahteve_projektantov"
                label="6.c Opombe projektantov in drugih strokovnjakov"
                :messages="siteLog.opombe_in_zahteve_projektantov ? ['Prejšnji vnosi: ' + siteLog.opombe_in_zahteve_projektantov] : []"
                auto-grow
                data-cy="public-qa-note-op6c"
              />

              <v-textarea
                v-model="notes.opombe_in_zahteve_soglasodajalcev"
                label="6.d Opombe soglasodajalcev"
                :messages="siteLog.opombe_in_zahteve_soglasodajalcev ? ['Prejšnji vnosi: ' + siteLog.opombe_in_zahteve_soglasodajalcev] : []"
                auto-grow
                data-cy="public-qa-note-op6d"
              />

              <v-card-actions class="justify-end">
                <v-btn
                  color="primary"
                  variant="outlined"
                  :loading="saving"
                  data-cy="public-qa-submit"
                  @click="saveNotes"
                >
                  Naprej
                </v-btn>
              </v-card-actions>
            </v-stepper-window-item>

            <v-stepper-window-item :value="3">
              <v-alert
                type="success"
                data-cy="public-qa-success"
              >
                Sedaj lahko zaprete okno brskalnika.
              </v-alert>

              <v-card-actions class="justify-end">
                <v-btn
                  color="primary"
                  variant="outlined"
                  data-cy="public-qa-download"
                  @click="downloadSiteLog"
                >
                  Prenos dnevnega lista
                </v-btn>
              </v-card-actions>

              <PdfPreview
                v-if="step == 3"
                :document-url="documentUrl"
              />
            </v-stepper-window-item>
          </v-stepper-window>
        </v-stepper>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import PdfPreview from '@/views/components/PdfPreview';
import axios from 'axios';

export default {
  name: "PublicQualityAssurancePreview",
  components: { PdfPreview },
  data() {
    return {
      step: 1,
      documentUrl: '',
      projectId: null,
      siteLogId: null,
      siteLog: {
        dopolnilni_del: '',
        opombe_in_zahteve_odgovornega_vodje: '',
        opombe_in_zahteve_inspekcijskih_sluzb: '',
        opombe_in_zahteve_projektantov: '',
        opombe_in_zahteve_soglasodajalcev: '',
      },
      user: null,
      notes: {
        dopolnilni_del: '',
        opombe_in_zahteve_odgovornega_vodje: '',
        opombe_in_zahteve_inspekcijskih_sluzb: '',
        opombe_in_zahteve_projektantov: '',
        opombe_in_zahteve_soglasodajalcev: '',
        signature_odgovorni: null,
      },
      saving: false
    }
  },
  async created() {
    const requestData = JSON.parse(atob(this.$route.query.d));
    this.projectId = requestData.project_id;
    this.siteLogId = requestData.site_log_id;
    this.secret = requestData.key;
    this.documentUrl = `${this.$config.API_PDF_EXPORT_BASE}/dnevni-list/${this.projectId}/${requestData.date},${requestData.sequence}`;

    this.siteLog = (await axios.get(`${this.$config.API_SIGN_SITELOG}?siteLogId=${this.siteLogId}`, {
      headers: {
        Authorization: this.secret
      }
    })).data.sitelog;

    this.notes = {
      dopolnilni_del: '',
      opombe_in_zahteve_odgovornega_vodje: '',
      opombe_in_zahteve_inspekcijskih_sluzb: '',
      opombe_in_zahteve_projektantov: '',
      opombe_in_zahteve_soglasodajalcev: '',
    }
  },
  methods: {
    async saveNotes() {
      this.saving = true;

      const requestBody = {
        dopolnilni_del: this.notes.dopolnilni_del,
        opombe_in_zahteve_odgovornega_vodje: this.notes.opombe_in_zahteve_odgovornega_vodje,
        opombe_in_zahteve_inspekcijskih_sluzb: this.notes.opombe_in_zahteve_inspekcijskih_sluzb,
        opombe_in_zahteve_projektantov: this.notes.opombe_in_zahteve_projektantov,
        opombe_in_zahteve_soglasodajalcev: this.notes.opombe_in_zahteve_soglasodajalcev,
      }

      try {
        await axios.post(
            `${this.$config.API_SIGN_SITELOG}?siteLogId=${this.siteLogId}`,
            requestBody,
            {
              headers: {
                Authorization: this.secret
              }
            }
        );

        this.step = 3;
      } finally {
        this.saving = false;
      }
    },
    downloadSiteLog() {
      window.open(this.documentUrl, '_blank');
    },
  }
}
</script>
